import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/signup-applications/')({
  beforeLoad: () => {
    throw redirect({ to: '/signup-applications' })
  },
})
